module.exports = __webpack_public_path__ + "img/TOS-1.d88025d7.jpg";